<template>
  <section class="lymphomap_main">
    <div class="algo_data_table_wrp">
      <div class="container-fluid">
        <!-- Top Header -->
        <div class="data_top_header_section">
          <div class="row align-items-center">
            <div class="col">
              <h2 class="main_heading">
                <button type="button" class="btn back_btn" tapable @click="$router.go(-1)">
                  <i class="fa fa-chevron-left" aria-hidden="true"></i>
                </button>Data
              </h2>
            </div>
            <div class="col-md-auto right_btns">
              <button class="btn btn-success mr-2" @click="openPopup('dataInstructionPopupState')">Instructions</button>
              <button class="btn btn-primary" @click="openPopup('uploadDataPopupState')">Upload Data</button>
            </div>
          </div>
        </div>

        <!-- Filter Carousel Tabs -->
        <div class="row mt-2">
          <div class="col">
            <div class="all_user_list_wrp">
              <carousel
                :mouseDrag="false"
                :touchDrag="false"
                :autoplay="false"
                :loop="false"
                :nav="false"
                :margin="15"
                :dots="false"
                :items="4"
                :responsive="{ 0: { items: 1 }, 1024: { items: 4 }, 1900: { items: 6 } }"
              >
                <template slot="prev">
                  <span class="all_users_slider_arrow member_slider_prev">
                    <i class="fa fa-angle-left" aria-hidden="true"></i>
                  </span>
                </template>

                <div v-for="tab in tabConfigs" :key="tab.id" class="carousel_item">
                  <div
                    class="total_count_box"
                    :class="{ active: filterTabsChangedState === tab.id }"
                    @click="filterTabsChangesMethod(tab.id)"
                    :id="'filtered' + tab.id"
                  >
                    <div class="count_icon">
                      <span class="filter_cat_img_box">
                        <i v-if="tab.iconClass" :class="tab.iconClass" aria-hidden="true"></i>
                        <img v-else :src="tab.iconSrc" class="img-fluid" :style="{ width: tab.iconWidth || '50px' }" />
                      </span>
                    </div>
                    <div class="count_title_w_n">
                      <span class="count_title">
                        <div class="global_filter_name_in_html">{{ tab.title }}</div>
                      </span>
                    </div>
                  </div>
                </div>

                <template slot="next">
                  <span class="all_users_slider_arrow member_slider_next">
                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                  </span>
                </template>
              </carousel>
            </div>
          </div>
        </div>

        <!-- Tab Content Sections -->
        <div class="filter_cat_box_list">
          <div class="filter_cat_box_list_inner">
            
            <!-- Public / Private Org Data Views -->
            <div
              v-if="filterTabsChangedState === 'public_data' || filterTabsChangedState === 'private_data'"
              class="filter_cat_box_tabs"
              :class="{ active: filterTabsChangedState === 'private_data' }"
            >
              <template v-if="currentOrgData">
                <div class="row" v-if="currentOrgDataResults.length > 0">
                  <div class="col-sm-3" v-for="(item, index) in currentOrgDataResults" :key="index">
                    <div
                      class="user_filters_list_item"
                      @click="userFiltersInfoPopupMethod(item.area_of_work, filterTabsChangedState === 'public_data' ? 'True' : 'False')"
                    >
                      <div class="user_filters_item_info">
                        <div class="user_filters_wrp">
                          <div class="filter_info_con">
                            <span class="user_filters_title">{{ item.area_of_work }}</span>
                            <span class="filter_country_flag">
                              <img :src="getCountryFlag(item.country)" class="country-flag" />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" v-else>
                  <div class="col-sm-12 mt-4">
                    <div class="alert alert-default mb-0" role="alert">
                      You don't have any {{ filterTabsChangedState === 'public_data' ? 'public' : 'private' }} data.
                    </div>
                  </div>
                </div>
              </template>
              <div class="fixloader" v-else>
                <div class="spinner spinner-1"></div>
              </div>
            </div>

            <!-- Shared Data Routing -->
            <div
              v-else-if="filterTabsChangedState === 'shared_data'"
              class="filter_cat_box_tabs active"
            >
              <div class="row">
                <div class="col-sm-3">
                  <div class="user_filters_list_item" @click="sharedDataFilterMethod('incoming')">
                    <div class="user_filters_item_info">
                      <div class="user_filters_wrp">
                        <div class="filter_info_con">
                          <span class="user_filters_title">Incoming</span>
                          <span class="cloud_icon_filter">
                            <i class="fa fa-cloud-download" aria-hidden="true"></i>
                          </span>
                          <span class="user_filters_desc">The datasets shared with you</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="user_filters_list_item" @click="sharedDataFilterMethod('outgoing')">
                    <div class="user_filters_item_info">
                      <div class="user_filters_wrp">
                        <div class="filter_info_con">
                          <span class="user_filters_title">Outgoing</span>
                          <span class="cloud_icon_filter">
                            <i class="fa fa-cloud-upload" aria-hidden="true"></i>
                          </span>
                          <span class="user_filters_desc">The datasets you share to others</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- My Data & Trash Data Unified Table -->
            <div
              v-else-if="filterTabsChangedState === 'my_data' || filterTabsChangedState === 'trash_data'"
              class="filter_cat_box_tabs active"
            >
              <table class="table table_algo_data" v-if="activeTableLoaded">
                <thead>
                  <tr>
                    <th width="22%">Title</th>
                    <th width="28%">Category</th>
                    <th width="12%">Date</th>
                    <th width="20%" class="text-center">File</th>
                    <th width="10%" class="text-center">Status</th>
                    <th width="10%" class="text-right">Action</th>
                  </tr>
                  <tr class="empty_cell">
                    <th colspan="2"></th>
                  </tr>
                </thead>
                <tbody v-if="activeTableRows.length > 0">
                  <tr v-for="(row, idx) in activeTableRows" :key="idx">
                    <td>{{ getRowField(row, 'header') }}</td>
                    <td>{{ getRowField(row, 'category') }}</td>
                    <td>{{ getRowField(row, 'created_at') | LocalDateFormat }}</td>
                    
                    <td class="text-center">
                      <a
                        v-if="getRowField(row, 'data_file')"
                        :href="getRowField(row, 'data_file')"
                        target="_blank"
                      >
                        {{ getRowField(row, 'data_file_name') }}
                      </a>
                      <a
                        v-else
                        href="javascript:void(0)"
                        @click="downloadFileMethod(getRowField(row, 'id'))"
                      >
                        {{ getRowField(row, 'data_file_name') }}
                      </a>
                    </td>

                    <td class="text-center">
                      <input
                        type="checkbox"
                        :class="{ checked: getRowField(row, 'is_public') }"
                        :id="'alogDataPublish' + getRowField(row, 'id')"
                        hidden="hidden"
                      />
                      <label
                        :for="'alogDataPublish' + getRowField(row, 'id')"
                        class="custom_round_switch"
                        :title="getRowField(row, 'is_public') ? 'Public' : 'Private'"
                      >
                        <span></span>
                      </label>
                    </td>

                    <td :class="row.shared ? 'text-right' : ''">
                      <span v-if="row.shared" style="font-weight:normal;font-size: 16px;" class="badge badge-primary">Is Shared</span>
                      
                      <!-- Trash action -->
                      <ul v-else-if="filterTabsChangedState === 'trash_data'" class="action_list">
                        <li>
                          <button class="btn btn-success mr-3" @click="restoreDataMethod(row.id)">
                            <i class="fa fa-repeat" aria-hidden="true"></i>
                          </button>
                        </li>
                      </ul>

                      <!-- Active My Data actions -->
                      <ul v-else class="action_list">
                        <li>
                          <button class="btn btn-danger" @click="deleteDataFromListMethod(row.id)">
                            <i class="fa fa-trash"></i>
                          </button>
                        </li>
                        <li>
                          <button class="btn btn-secondary" @click="sharedDatasetMethod(row)">
                            <i class="fa fa-share-alt"></i>
                          </button>
                        </li>
                        <li>
                          <button class="btn btn-primary" @click="updateAlogDataDetailsMethod(row.id)">
                            <i class="fa fa-pencil"></i>
                          </button>
                        </li>
                      </ul>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr class="text-center">
                    <td colspan="6">You don't have any data.</td>
                  </tr>
                </tbody>
              </table>
              <div class="fixloader" v-else>
                <div class="spinner spinner-1"></div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- Info Modal Popup -->
      <div class="user_filters_info_popup_main" v-if="userFilterInfoPopupState">
        <div class="user_filters_info_popup" :class="{ active: userFilterInfoPopupStateClass }">
          <div class="user_filters_info_modal">
            <div class="user_filters_info_modal_center">
              <div class="user_filters_info_inner">
                <div class="row align-items-center">
                  <div class="col">
                    <template v-if="filterTabsChangedState === 'shared_data'">
                      <h2 class="user_filters_info_heading pt-2">
                        Shared Datasets - <span style="text-transform: capitalize;">{{ catStateProp }}</span>
                      </h2>
                      <h6 class="filter_subheading" v-if="catStateProp === 'incoming'">
                        Listed below are the datasets your connections on Lymphomap have shared with you.
                      </h6>
                      <h6 class="filter_subheading" v-else>
                        Listed below are the datasets your connections on Lymphomap have shared with you.
                      </h6>
                    </template>
                    <h2 class="user_filters_info_heading" v-else>{{ userFilterInfoData }}</h2>
                  </div>
                  <div class="col-auto text-right">
                    <div class="user_filters_info_close">
                      <span class="user_filters_info_close_span">
                        <i aria-hidden="true" class="fa fa-times-circle" @click="clickedOutside"></i>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="user_filters_info_content pt-3">
                  <div class="container-fluid">
                    <shared-data-list v-if="filterTabsChangedState === 'shared_data'" :catStatePROP="catStateProp" />
                    <org-based-data-list v-else :orgKeyword="userFilterInfoData" :catStatePROP="catStateProp" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Child Modals -->
      <upload-data-popup v-if="uploadDataPopupState" />
      <update-date-popup v-if="updateAlgoDataPopupState" :updateAlgoDataID="updateAlgoDataId" />
      <restore-data-popup v-if="restoreDataState" :restoreDataID="restoreDataId" />
      <delete-data-popup v-if="deletePopupState" :deleteDataID="deleteDataId" />
      <shared-dataset-popup v-if="sharedDatasetPopupState" :sharedDatasetInfo="sharedDatasetInfo" />
      <data-instruction-popup v-if="dataInstructionPopupState" />
    </div>
  </section>
</template>

<script>
/*eslint-disable */

import { bus } from '@/main';
import carousel from 'vue-owl-carousel';
import countries from '@/services/country.json';
import dataInstructionPopup from '@/components/private/dataset/data-instruction-popup/';
import deleteDataPopup from './delete-data-popup/';
import orgBasedDataList from './data-list-based-on-org/';
import restoreDataPopup from './restore-data-popup/';
import sharedDataList from './shared-data-list/';
import sharedDatasetPopup from '@/components/private/dataset/data-shared-popup/';
import updateDataPopup from '../update-algo-data-details/';
import uploadDataPopup from '../create-algo-data-details/';
import { mapGetters } from 'vuex';

const $ = (window.jQuery = require('jquery'));

export default {
  name: 'algo-dashboard',
  components: {
    carousel,
    'upload-data-popup': uploadDataPopup,
    'update-date-popup': updateDataPopup,
    'org-based-data-list': orgBasedDataList,
    'delete-data-popup': deleteDataPopup,
    'restore-data-popup': restoreDataPopup,
    'shared-data-list': sharedDataList,
    'shared-dataset-popup': sharedDatasetPopup,
    'data-instruction-popup': dataInstructionPopup
  },
  props: [],
  data() {
    return {
      filterTabsChangedState: 'public_data',
      userFilterInfoData: '',
      userFilterInfoPopupState: false,
      userFilterInfoPopupStateClass: false,

      orgPublicBasedData: null,
      orgPublicBasedDataResults: [],
      orgPrivateBasedData: null,
      orgPrivateBasedDataResults: [],

      myListData: null,
      myListDataResults: [],
      deletedDataList: null,
      deletedDataListArr: [],

      uploadDataPopupState: false,
      updateAlgoDataPopupState: false,
      updateAlgoDataId: '',
      catStateProp: '',
      restoreDataState: false,
      restoreDataId: '',
      deletePopupState: false,
      deleteDataId: '',
      sharedDatasetPopupState: false,
      sharedDatasetInfo: null,
      dataInstructionPopupState: false,

      tabConfigs: [
        { id: 'public_data', title: 'Public Data', iconSrc: require('@/assets/images/filter_icon/public_data.png') },
        { id: 'private_data', title: 'Private Data', iconSrc: require('@/assets/images/filter_icon/private_data.png') },
        { id: 'shared_data', title: 'Shared Data', iconSrc: require('@/assets/images/filter_icon/data-sharing.png') },
        { id: 'my_data', title: 'My Data', iconSrc: require('@/assets/images/filter_icon/my_data.png'), iconWidth: '40px' },
        { id: 'trash_data', title: 'Recycle Bin', iconClass: 'fa fa-trash' }
      ]
    };
  },
  computed: {
    ...mapGetters(['selfUserInfoGetters']),
    userProfileDetails() {
      return (this.selfUserInfoGetters && this.selfUserInfoGetters.data) || null;
    },
    pro_payment() {
      return !!(this.userProfileDetails && this.userProfileDetails.pro_payment);
    },
    auto_payment() {
      return !!(this.userProfileDetails && this.userProfileDetails.auto_payment);
    },
    regular_payment() {
      return !!(this.userProfileDetails && this.userProfileDetails.regular_payment);
    },
    countryMap() {
      var map = {};
      Object.keys(countries).forEach(function (key) {
        map[key.toLowerCase()] = key.toLowerCase();
        map[countries[key].toLowerCase()] = key.toLowerCase();
      });
      return map;
    },
    currentOrgData() {
      return this.filterTabsChangedState === 'public_data'
        ? this.orgPublicBasedData
        : this.orgPrivateBasedData;
    },
    currentOrgDataResults() {
      return this.filterTabsChangedState === 'public_data'
        ? this.orgPublicBasedDataResults
        : this.orgPrivateBasedDataResults;
    },
    activeTableLoaded() {
      return this.filterTabsChangedState === 'trash_data'
        ? this.deletedDataList !== null
        : this.myListData !== null;
    },
    activeTableRows() {
      return this.filterTabsChangedState === 'trash_data'
        ? this.deletedDataListArr
        : this.myListDataResults;
    }
  },
  created() {
    this.registerBusListeners();
  },
  mounted() {
    this.getOrgPublicBasedDataMethod();
    this.getOrgPrivateBasedDataMethod();
    this.getMyDataListMethod();
    this.getDeletedDataListMethod();
  },
  beforeDestroy() {
    this.unregisterBusListeners();
    document.body.classList.remove('body_right_scroll_remove');
  },
  methods: {
    registerBusListeners() {
      this._handlers = {
        createAlgoDataPopupBus: (data) => {
          this.uploadDataPopupState = data;
          this.getMyDataListMethod();
        },
        updateAlgoDataPopupBus: (data) => {
          this.updateAlgoDataPopupState = data;
          this.getMyDataListMethod();
        },
        restoreDataStateBus: (data) => {
          this.restoreDataState = data;
          this.getMyDataListMethod();
          this.getDeletedDataListMethod();
        },
        deletePopupStateBus: (data) => {
          this.deletePopupState = data;
          this.getMyDataListMethod();
          this.getDeletedDataListMethod();
        },
        sharedDatasetStateBus: (data) => {
          this.sharedDatasetPopupState = data;
        },
        dataInstructionPopupStateBus: (data) => {
          this.dataInstructionPopupState = data;
        }
      };

      Object.keys(this._handlers).forEach((event) => {
        bus.$on(event, this._handlers[event]);
      });
    },
    unregisterBusListeners() {
      if (!this._handlers) return;
      Object.keys(this._handlers).forEach((event) => {
        bus.$off(event, this._handlers[event]);
      });
    },
    openPopup(popupKey) {
      this[popupKey] = true;
      document.body.classList.add('body_right_scroll_remove');
    },
    deleteDataFromListMethod(id) {
      this.deleteDataId = id;
      this.openPopup('deletePopupState');
    },
    restoreDataMethod(id) {
      this.restoreDataId = id;
      this.openPopup('restoreDataState');
    },
    sharedDatasetMethod(data) {
      this.sharedDatasetInfo = data;
      this.openPopup('sharedDatasetPopupState');
    },
    updateAlogDataDetailsMethod(algoId) {
      this.updateAlgoDataId = algoId;
      this.openPopup('updateAlgoDataPopupState');
    },
    filterTabsChangesMethod(tabId) {
      this.filterTabsChangedState = tabId;
    },
    getMyDataListMethod() {
      this.$store.dispatch('getAlgoDataListAction').then((res) => {
        this.myListData = res.data;
        this.myListDataResults = (this.myListData && this.myListData.data) || [];
      });
    },
    getDeletedDataListMethod() {
      this.$store.dispatch('deletedDataListAction').then((res) => {
        this.deletedDataList = res.data;
        this.deletedDataListArr = (this.deletedDataList && this.deletedDataList.data) || [];
      });
    },
    getOrgPublicBasedDataMethod() {
      this.$store.dispatch('getPublicAlgoDataBasedOrgAction').then((res) => {
        this.orgPublicBasedData = res.data.data;
        this.orgPublicBasedDataResults = (this.orgPublicBasedData && this.orgPublicBasedData.results) || [];
      });
    },
    getOrgPrivateBasedDataMethod() {
      this.$store.dispatch('getPrivateAlgoDataBasedOrgAction').then((res) => {
        this.orgPrivateBasedData = res.data.data;
        this.orgPrivateBasedDataResults = (this.orgPrivateBasedData && this.orgPrivateBasedData.results) || [];
      });
    },
    getRowField(row, field) {
      return (row.shared && row.algo_data) ? row.algo_data[field] : row[field];
    },
    clickedOutside() {
      this.userFilterInfoPopupStateClass = false;
      setTimeout(() => {
        this.userFilterInfoPopupState = false;
        document.body.classList.remove('body_right_scroll_remove');
        this.userFilterInfoData = '';
        this.catStateProp = '';
      }, 600);
    },
    sharedDataFilterMethod(catState) {
      this.catStateProp = catState;
      this.showFilterModal();
    },
    userFiltersInfoPopupMethod(data, catState) {
      this.catStateProp = catState;
      this.userFilterInfoData = data;
      this.showFilterModal();
    },
    showFilterModal() {
      window.scrollTo(0, 0);
      this.userFilterInfoPopupState = true;
      document.body.classList.add('body_right_scroll_remove');
      setTimeout(() => {
        this.userFilterInfoPopupStateClass = true;
      }, 10);
    },
    getCountryFlag(countryCode) {
        const code = (countryCode || 'IN').toUpperCase();
        try {
            return require(`@/assets/images/countries/${code}.svg`);
        } catch (e) {
            return require('@/assets/images/countries/IN.svg');
        }
    },
    selectedAlgoDataDetailsByIdMethod(dataId) {
      this.$store.dispatch('getAllPubAlgoDataListByIdAction', { id: dataId }).then((res) => {
        this.downloadFileMethod(res.data.data.data_file, res.data.data.data_file_name);
      }).catch((err) => {});
    },
    downloadFileMethod(file, fileName) {
      if (!file) return;
      var link = document.createElement('a');
      link.href = file;
      link.download = fileName || 'download';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  },
  beforeRouteLeave(to, from, next) {
    $('body').removeClass('notConnectedUserBody');
    document.body.classList.remove('body_right_scroll_remove');
    next();
  }
};
</script>

<style lang="scss" scoped>
.algo_data_table_wrp {
    color: #ffffff;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
    letter-spacing: 1px;

    .top_brd {
        border-top: 1px solid rgba(255, 255, 255, 0.1);
    }

    .table.table_algo_data {
        margin-bottom: 0;
        letter-spacing: 0.5px;
        color: #ffffff;
        border-collapse: separate;
        border-spacing: 0 3px;

        >thead th {
            border-bottom: 0;
            font-size: 19px;
            padding: 10px 8px;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            text-transform: uppercase;
            border-top: 0px;
            transition: all ease 0.5s;
            -webkit-transition: all ease 0.5s;
            -moz-transition: all ease 0.5s;
            background: rgba(228, 233, 237, .1);
            color: #87cefa;
            word-spacing: 5px;
        }

        >thead .empty_cell th {
            padding: 0px !important;
            background: none !important;
        }

        >tbody tr td {
            color: #ffffff;
            vertical-align: top;
            padding: 20px 8px;
            font-size: 20px;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            transition: all ease 0.5s;
            -webkit-transition: all ease 0.5s;
            -moz-transition: all ease 0.5s;
            border-top: 0px;
            background: rgba(228, 233, 237, .1);

            &.meeting_cell_date {
                color: #fff8d8;
            }

            .data_file_link {
                display: block;
                word-break: break-all;
                cursor: pointer;
            }

            a {
                color: #ffc107;

                &:hover {
                    color: #87cefa;
                }
            }
        }

        a:hover {
            text-decoration: none;
        }

        .member_user_avtaar {
            display: inline-block;
            vertical-align: middle;
            position: relative;

            img {
                width: 60px;
                height: 60px;
                border-radius: 50%;
                cursor: pointer;
            }
        }

        .online-status {
            position: absolute;
            right: 4px;
            bottom: 2px;
            border: 1px solid #9E9E9E;
            border-radius: 50%;
            width: 12px;
            height: 12px;
            background: #9E9E9E;

            &.online {
                background-color: #4CAF50;
                border-color: #4CAF50;
            }

            &.busy {
                background-color: #F44336;
                border-color: #F44336;
            }
        }

        .member_user_info {
            display: inline-block;
            vertical-align: middle;
            width: calc(100% - 70px);
            margin-left: 10px;
        }

        .member_user_name {
            line-height: 1;
            font-size: 20px;
            color: #fff;
            display: block;
            cursor: pointer;
            transition: all ease 0.5s;
            -webkit-transition: all ease 0.5s;
            -moz-transition: all ease 0.5s;

            a {
                color: #ffffff;
                text-decoration: none;
            }
        }

        .member_join_date {
            line-height: 1;
            font-size: 16px;
            color: #fff;
            display: block;
        }

        .member_user_email,
        .member_join_time {
            font-size: 15px;
            color: hsla(0, 0%, 100%, .5);
            white-space: pre-wrap;
            word-break: break-all;
            display: block;
        }

        .country-flag {
            width: 45px;
            display: inline-block;
            vertical-align: middle;
            margin-right: 5px;
            // height: 64px;
            object-fit: cover;
        }

        .country-flag-name {
            width: calc(100% - 55px);
            display: inline-block;
            vertical-align: middle;
            line-height: 1.2;
        }

        .btn-success.member_user_video_call_btn {
            padding: 7px 12px;
            font-size: 18px;
            border-radius: 70px;
            background: rgba(255, 255, 255, 0.12);
            color: #ffd400;
            border: none;
            margin-right: 0px;
            text-transform: capitalize;
            font-weight: 400;
            letter-spacing: .03em;
            line-height: 1;
            box-shadow: none !important;

            &:hover,
            &:focus {
                background: #87cefa;
                color: #22292f;
                border-color: #87cefa;
            }

            &:disabled {
                cursor: not-allowed;
            }
        }
    }

    .main_heading {
        color: #ffffff;
        font-size: 28px;
        text-transform: uppercase;
        font-weight: bold;
        margin: 0px;
    }

    .btn-primary {
        cursor: pointer;
        box-shadow: none !important;
        outline: none !important;

        &:hover {
            background: #87cefa;
            color: #000;
            border-color: #87cefa;
        }
    }

    .action_list {
        display: flex;
        margin: 0;
        justify-content: flex-end;
        padding-right: 3px;

        li {
            margin-left: 10px;

            &:first-child {
                margin-left: 0px;
            }

            .btn {
                padding: 2px 8px;
                outline: none !important;
                box-shadow: none !important;

                &.btn-success {
                    color: #ffff;
                    background-color: #00b388;
                    border-color: #00b386;

                    &:hover {
                        background: #87cefa;
                        color: #000000;
                        border-color: #87cefa;
                    }
                }
            }
        }
    }

    .remove_data_task_modal {
        position: fixed;
        top: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.92);
        left: 0;
        right: 0;
        z-index: 1000;
        display: flex;
        align-items: center;
    }

    .remove_data_task_modal_body {
        background: #000;
        width: 480px;
        margin: 0px auto;
        border-radius: 5px;
        padding: 20px 25px;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        color: #ffffff;
        -webkit-box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
        box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
    }

    .remove_data_task_header h2 {
        font-size: 18px;
        color: #ffffff;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        text-align: center;
        margin: 0 0 30px;
    }

    .remove_yes_btn {
        font-size: 16px;
        background: rgba(255, 18, 18, 0.5);
        color: #fff;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        padding: 10px 5px;
        min-width: 100px;
        line-height: 1;
        border-radius: 3px !important;
        outline: none !important;
        box-shadow: none !important;

        &:hover {
            background: #ffe738 !important;
            color: #22292f !important;
        }
    }

    .remove_yes_no {
        font-size: 16px;
        background: rgba(33, 228, 0, 0.5);
        color: #fff;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        padding: 10px 5px;
        min-width: 100px;
        line-height: 1;
        margin-left: 15px;
        border-radius: 3px !important;
        outline: none !important;
        box-shadow: none !important;

        &:hover {
            background: #ffe738 !important;
            color: #22292f !important;
        }
    }

    .remove_data_task_btn {
        text-align: center;
    }

    .remove_data_task_btn {
        text-align: center;
    }

    .custom_round_switch {
        vertical-align: middle;
        margin-bottom: 0;
        margin-top: 3px;

        span {
            width: 20px;
            height: 20px;
            background: #da1b22;
            cursor: pointer;
            position: relative;
            display: inline-block;
            vertical-align: middle;
            border-radius: 50%;

            &:before {
                content: "";
                width: 10px;
                height: 10px;
                background: #fff;
                position: absolute;
                margin: auto;
                top: 0;
                bottom: 0;
                right: 0;
                left: 0;
                border-radius: 50%;
            }
        }
    }

    input[type=checkbox].checked+.custom_round_switch span {
        background: #36b04c;
    }

    .load_more_btn {
        color: #fff !important;
        background: rgba(255, 255, 255, 0.1);
        padding: 5px;
        min-width: 110px;
        font-size: 16px;
        border-radius: 3px;
        border: 0 !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        margin: 15px 0;
    }

    .load_more_btn:hover {
        color: #000 !important;
        background: #87cefa;
    }

    /* Toggle button styles */
    .onoffswitch {
        position: relative;
        width: 55px;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
    }

    .onoffswitch-checkbox {
        display: none;
    }

    .onoffswitch-label {
        display: block;
        overflow: hidden;
        cursor: pointer;
        border: 0px solid #999999;
        border-radius: 20px;
    }

    .onoffswitch-inner {
        display: block;
        width: 200%;
        margin-left: -100%;
        transition: margin 0.3s ease-in 0s;
    }

    .onoffswitch-inner:before,
    .onoffswitch-inner:after {
        display: block;
        float: left;
        width: 50%;
        height: 25px;
        padding: 0;
        line-height: 25px;
        font-size: 13px;
        color: white;
        font-weight: bold;
        box-sizing: border-box;
    }

    .onoffswitch-inner:before {
        content: "";
        padding-left: 10px;
        background-color: #36B04C;
        color: #FFFFFF;
    }

    .onoffswitch-inner:after {
        content: "";
        padding-right: 10px;
        background-color: #DA1B22;
        color: #FFFFFF;
        text-align: right;
    }

    .onoffswitch-switch {
        display: block;
        width: 17px;
        margin: 4px;
        background: #FFFFFF;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 31px;
        border: 0px solid #999999;
        border-radius: 13px;
        transition: all 0.3s ease-in 0s;
    }

    .onoffswitch-checkbox:checked+.onoffswitch-label .onoffswitch-inner {
        margin-left: 0;
    }

    .onoffswitch-checkbox:checked+.onoffswitch-label .onoffswitch-switch {
        right: 0px;
    }

    .user_event_info {
        margin-top: 10px;
        display: block;

        .btn-primary {
            padding: 1px 8px;
            font-size: 13px;
            border-radius: 50px;
            background: rgba(255, 255, 255, 0.1);
            color: #ffffff;
            border: none;
            margin-right: 5px;

            &:hover {
                background: #87cefa;
                color: #000000;
            }
        }
    }

    .user_not_connected_popup h3 {
        font-size: 20px;
        letter-spacing: 0;
        text-align: center;
    }

    .user_not_connected_popup .remove_data_task_modal_body {
        padding: 50px 30px;
        margin: 15vh auto 0;
        width: 500px;
        text-align: center;
    }

    .connected_user_info_popup {
        .remove_data_task_modal_body {
            width: 560px !important;
            position: relative;

            h3 {
                font-size: 22px;
                letter-spacing: 0;
                margin-bottom: 15px;
            }

            .connected_user_info_closed_icon {
                position: absolute;
                top: 5px;
                right: 8px;
                line-height: 1;

                .fa {
                    font-size: 20px;
                    color: red;
                    cursor: pointer;
                    transform: scale(1);
                    -webkit-transform: scale(1);
                    -moz-transform: scale(1);
                    transition: all ease 0.5s;

                    &:hover {
                        transform: scale(1.1);
                        -webkit-transform: scale(1.1);
                        -moz-transform: scale(1.1);
                    }
                }
            }
        }
    }

    .request_send_popup .form-control {
        background: rgba(255, 255, 255, 0.1) !important;
        border: none;
        color: #fff;
    }

    .request_send_popup h3 {
        font-size: 22px;
        letter-spacing: 0;
    }

    .badge {
        font-weight: normal;
        font-size: 13px;
        margin-bottom: 0px;
    }

    .request_send_popup .remove_data_task_modal_body {
        text-align: center;
    }

    .add_user_btn {
        cursor: pointer;
        position: relative;
        min-width: 95px;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        outline: none !important;
        background: rgba(255, 255, 255, 0.2);
        color: #ffffff;
        border: none;
        border-radius: 3px;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;

        &:hover {
            background: #87cefa;
            color: #000;
            border-color: #87cefa;
        }
    }

    .delete_users_wrp h5 {
        margin: 0;
        font-size: 22px;
        padding: 15px 0;
        font-weight: 700;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        text-transform: uppercase;
        color: #fbfbd6;
    }

    .table_section_heading h5 {
        margin: 0;
        font-size: 22px;
        padding: 15px 0;
        font-weight: 700;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        text-transform: uppercase;
        color: #fbfbd6;
    }

    .filtering_list {
        background: rgba(255, 255, 255, 0.2);
        border: none;
        color: #fff;
        outline: none;
        box-shadow: none;
        width: 180px;

        option {
            color: #000000;
        }
    }

    .all_user_list_wrp {
        padding: 12px 0;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        position: relative;

        .total_count_box {
            background: rgba(228, 233, 237, 0.1);
            padding: 0 0 0px 18px;
            border-radius: 5px;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            cursor: pointer;
            color: #fff;
            height: 135px;

            &:hover {
                background: #87cefa;
                color: #000000;
            }

            &:hover .count_icon path {
                fill: #000000;
            }

            &:hover .count_icon circle {
                fill: #000000;
            }

            &:hover .count_icon rect {
                fill: #000000;
            }

            &:hover .count_icon span {
                background: rgba(0, 0, 0, 0.1)
            }

            &.active {
                background: #87cefa;
                color: #000000;
            }

            &.active .count_icon path {
                fill: #000000;
            }

            &.active .count_icon circle {
                fill: #000000;
            }

            &.active .count_icon rect {
                fill: #000000;
            }

            &.active .count_icon span {
                background: rgba(255, 255, 255, 0.15);
            }

            &:hover .count_icon span .img-fluid {
                filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(100deg) brightness(0%) contrast(100%);
                -webkit-filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(100deg) brightness(0%) contrast(100%);
            }

            &.active .count_icon span .img-fluid {
                filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(100deg) brightness(0%) contrast(100%);
                -webkit-filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(100deg) brightness(0%) contrast(100%);
            }

            .filter_cat_img_box {
                .fa {
                    font-size: 42px;
                    line-height: 70px;
                    color: #ffc107;
                }
            }

            &:hover .fa,
            &.active .fa {
                color: #000000;
            }
        }

        .count_icon span {
            width: 70px;
            display: inline-block;
            height: 70px;
            background: hsla(0, 0%, 100%, .1);
            border-radius: 50%;
            text-align: center;
            line-height: 70px;

            .img-fluid {
                display: inline-block;
            }
        }

        .count_title_w_n {
            padding-left: 15px;
        }

        .count_number {
            display: block;
            font-size: 22px;
            font-weight: 600;
        }

        .count_title {
            font-size: 20px;
            text-transform: capitalize;
            line-height: 1;
        }

        .row .col-sm-3 {
            padding-left: 6px;
            padding-right: 6px;
        }

        .row {
            margin-left: -6px;
            margin-right: -6px;
        }

        .carousel_item {
            a {
                text-decoration: none;
            }
        }
    }

    .all_users_slider_arrow {
        position: absolute;
        z-index: 1;
        top: 50%;
        left: -21px;
        transform: translateY(-50%);
        -webkit-transform: translateY(-50%);
        -moz-transform: translateY(-50%);

        // display:none;
        .fa {
            cursor: pointer;
            font-size: 42px;
            line-height: 28px;
            color: #ffc107;

            &:hover {
                color: #87cefa;
            }
        }

        &.member_slider_next {
            right: -21px;
            left: auto;
        }

        @media only screen and (max-width:767px) {
            display: block;
        }
    }

    .filter_cat_box_list {
        .user_filters_list_link {
            text-decoration: none;
        }

        .user_filters_list_item {
            padding: 0px 15px;
            border-radius: 20px;
            border: 1px solid rgba(123, 134, 138, .5);
            background: linear-gradient(180deg, rgba(51, 51, 51, .6), rgba(0, 0, 0, .75));
            text-align: center;
            margin: 15px 0;
            transition: all .3s ease;
            -webkit-transition: all .3s ease;
            -moz-transition: all ease .3s;
            transform: scale(1);
            -webkit-transform: scale(1);
            -moz-transform: scale(1);
            cursor: pointer;
            transform-origin: center center;
            height: 175px;
            align-items: center;
            display: flex;
            justify-content: center;

            &:hover {
                transform: scale(1.06);
                -webkit-transform: scale(1.06);
                -moz-transform: scale(1.06);
                border: 1px solid #769db4;
                background: rgba(144, 209, 249, .3);
            }

            .user_filters_title {
                color: #ffe400;
                font-size: 24px;
                margin-bottom: 5px;
            }

            .user_filters_desc {
                color: #fffcc4;
                font-size: 16px;
                font-family: 'MyriadProRegular', 'Lato', sans-serif;
                padding-top: 5px;
            }

            .cloud_icon_filter {
                padding: 10px 0 5px;

                .fa {
                    font-size: 50px;
                    color: #ffe400;
                }
            }
        }
    }

    .user_filters_info_popup_main {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 1001;

        .user_filters_info_popup {
            position: fixed;
            right: 0;
            top: 0;
            padding: 0;
            height: 100%;
            width: 100%;
            transition: all .7s cubic-bezier(.42, 1.14, 1, 1);
            -webkit-transition: all .7s cubic-bezier(.42, 1.14, 1, 1);
            -moz-transition: all .7s cubic-bezier(.42, 1.14, 1, 1);
            transform: translateX(100%);
            -webkit-transform: translateX(100%);
            -moz-transform: translateX(100%);

            &.active {
                -webkit-transform: translateX(0);
                -moz-transform: translateX(0);
                transform: translateX(0);
                overflow: hidden auto;
            }
        }

        .user_filters_info_modal {
            background: rgba(0, 0, 0, 0.94);
            color: #fff;
            min-height: 100%;
            line-height: normal;
            font-size: 20px;
        }

        .user_filters_info_close {
            text-align: right;
            padding: 10px 15px;

            .fa {
                color: #ffe400;
                font-size: 30px;
                cursor: pointer;

                &:hover {
                    color: #87cefa;
                }
            }
        }
    }

    .user_filters_info_heading {
        font-size: 28px;
        color: #ffd400;
        margin: 0;
        padding-left: 15px;
    }

    .filter_subheading {
        font-size: 18px;
        color: #FFFDD0;
        margin: 0;
        padding-left: 15px;
        font-weight: normal;
        padding-top: 5px;
    }

    .blurb_core_txt {
        display: block;
        font-size: 16px;
        font-weight: normal;
        text-transform: none;
        color: #ffd400;
        padding-left: 45px;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        padding-top: 5px;
    }

    .filter_info_con span {
        display: block;

        .country-flag {
            width: 50px;
        }
    }

    .alert.alert-default {
        color: #ffffff;
        padding: 20px 8px;
        font-size: 20px;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        transition: all ease 0.5s;
        -webkit-transition: all ease 0.5s;
        -moz-transition: all ease 0.5s;
        border-top: 0px;
        background: rgba(228, 233, 237, 0.1);
        text-align: center;
    }

    .data_top_header_section {
        .right_btns {
            @media only screen and (max-width:575px) {
                margin-top: 15px;
            }
            .btn {
                position: relative;
                min-width: 150px;
                box-shadow: none !important;
                outline: none;
                border: none;
                border-radius: 70px;
                font-family: 'MyriadProRegular', 'Lato', sans-serif;
                font-weight: 500;
                letter-spacing: 0.4px;
                font-size: 17px;
                line-height: 40px;
                padding: 0px 15px;
                @media only screen and (max-width:575px) {
                    min-width: inherit;
                    font-size: 16px;
                    line-height: 35px;
                    padding: 0px 20px;
                }
            }

            .btn-primary {
                background: rgba(104, 13, 13, 0.7);
                color: #fffcc4;

                &:hover {
                    background: #87cefa;
                    color: #000;
                }
            }

            .btn-success {
                background: rgba(22, 100, 9, 0.7);
                color: #ffffff;

                &:hover {
                    background: #87cefa;
                    color: #000;
                }
            }
        }
    }
}

@media only screen and (min-width:768px) and (max-width:1310px) {
    .algo_data_table_wrp .data_top_header_section .btn {
        font-size: 16px;
    }

    .algo_data_table_wrp .filter_cat_box_list .user_filters_list_item {
        height: 155px;
    }
}
</style>